<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    backTo: {
      type: [Object, String]
    },
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div
        class="page-title-box d-flex align-items-center justify-content-between pb-3"
      >
        <slot name="title">
          <h4 class="mb-0">{{ title }}</h4>
        </slot>

        <div class="page-title-right">
          <slot>
            <b-breadcrumb
              :items="items"
              class="m-0 my-2"
              v-if="items.length > 0"
            ></b-breadcrumb>
          </slot>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
